import { render, staticRenderFns } from "./goodsOpeation.vue?vue&type=template&id=2cb72ff9&scoped=true&"
import script from "./goodsOpeation.vue?vue&type=script&lang=js&"
export * from "./goodsOpeation.vue?vue&type=script&lang=js&"
import style0 from "./goodsOpeation.vue?vue&type=style&index=0&id=2cb72ff9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb72ff9",
  null
  
)

export default component.exports